<template>
  <b-row>
    <b-col md="6" offset-md="3">
      <b-card class="user-form" header-class="bg-primary" footer-class="card-footer-between" >
        <div slot="header" class="user-form-header">
          <span v-if="editUser" class="text-uppercase"><strong>{{ $t('COMMON.EDIT') }}</strong><strong> {{ $t('COMMON.USERS') }}</strong></span>
          <span v-else class="text-uppercase"><strong>{{ $t('USERS.ADD_NEW') }}</strong></span>
        </div>
        <b-col sm="12">
          <b-form-group>
            <label for="name">{{ $t('COMMON.NAME') }}</label>
            <input type="text"
                   class="form-control"
                   :class="{'is-invalid': $v.user.username.$error, 'is-valid': !$v.user.username.$invalid}"
                   :placeholder="$t('COMMON.NAME')"
                   v-model="user.username"
                   @blur="$v.user.username.$touch()">
            <b-form-invalid-feedback v-if="!$v.user.username.required">{{ $t('USERS.REQ_USERNAME') }}</b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!$v.user.username.alphaNum">{{ $t('USERS.REQ_ONLY_ALPHANUM') }}</b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!$v.user.username.minLen">{{ $t('USERS.REQ_MIN_LENGTH') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-form-group>
          <label for="name">{{ $t('USERS.EMAIL') }}</label>
          <input  type="email"
                  class="form-control"
                  :class="{'is-invalid': $v.user.email.$error, 'is-valid': !$v.user.email.$invalid}"
                  :placeholder="$t('USERS.EMAIL')"
                  v-model="user.email"
                  @blur="$v.user.email.$touch()">
          <b-form-invalid-feedback v-if="!$v.user.email.required">{{ $t('USERS.REQ_EMAIL') }}</b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="!$v.user.email.email"> {{ $t('USERS.REQ_VALID_EMAIL') }}</b-form-invalid-feedback>
        </b-form-group>
        <!-- <b-form-group>
          <label for="name">{{ $t('USERS.PASSWORD') }}</label>
          <input type="password"
                 class="form-control"
                 :class="{'is-invalid': $v.user.password.$error, 'is-valid': !$v.user.password.$invalid}"
                 :placeholder="$t('USERS.PASSWORD')"
                 v-model="user.password"
                 @blur="$v.user.password.$touch()">
          <b-form-invalid-feedback v-if="!$v.user.password.required">{{ $t('USERS.REQ_PASS') }}</b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="!$v.user.password.minLen">{{ $t('USERS.REQ_PASS_MIN_LENGHT') }}</b-form-invalid-feedback>
        </b-form-group> -->
        <!-- <b-form-group>
          <label for="name">{{ $t('USERS.PASS_CONFIRM') }}</label>
          <input type="password"
                 class="form-control"
                 :class="{'is-invalid': $v.user.repeat_password.$error, 'is-valid': !$v.user.repeat_password.$invalid}"
                 :placeholder="$t('USERS.REPEAT')"
                 v-model="user.repeat_password"
                 @blur="$v.user.repeat_password.$touch()">
          <b-form-invalid-feedback v-if="!$v.user.repeat_password.sameAs">{{ $t('USERS.REQ_NO_MATCH') }}</b-form-invalid-feedback>
        </b-form-group> -->
        <b-form-group v-if="editUser">
          <label for="name">{{ $t('COMMON.STATUS') }} </label>
          <span style="color:blue; font-style:italic"> * Deactivated users will be activated with update. </span>
          <input type="text" class="form-control" value="ACTIVE" disabled />
        </b-form-group>
        <b-form-group v-if="isSuperAdmin">
          <label for="name">{{ $t('COMMON.ACCOUNT') }}</label>
          <b-form-select :plain="true" v-model="user.account_id" :class="{'is-invalid': $v.user.account_id.$error, 'is-valid': !$v.user.account_id.$invalid}" >
            <template slot="first">
              <option value='' :disabled="true"> Please select an account </option>
            </template>
            <option :value="account.id" v-for="account in accounts">{{ account.name | capitalize }}</option>
          </b-form-select>
          <b-form-invalid-feedback v-if="!$v.user.account_id.required">{{ $t('USERS.REQ_ACCOUNT') }}</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group>
          <label for="name">{{ $t('USERS.ROLE') }}</label>
          <b-form-select :plain="true" v-model="user.role_id" :class="{'is-invalid': $v.user.role_id.$error, 'is-valid': !$v.user.role_id.$invalid}" >
            <template slot="first">
              <option value='' :disabled="true"> {{ $t('USERS.SELECT_ROLE') }} </option>
            </template>
            <option :value="role.id" v-for="role in roles">{{ role.name | capitalize }}</option>
          </b-form-select>
          <div class="error-message" v-if="roles.length === 0">{{ $t('USERS.CREATE_ROLE') }}</div>
          <b-form-invalid-feedback v-if="!$v.user.role_id.required">{{ $t('USERS.REQ_ROLE') }}</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group v-if="teams.length > 0 && isAdmin">
          <label for="name">{{ $t('USERS.TEAM') }}</label>
          <b-form-select :plain="true" v-model="user.team_id">
            <template slot="first">
              <option value=''>{{ $t('USERS.SELECT_TEAM') }}</option>
            </template>
            <option :value="team.id" v-for="team in teams">{{ team.name | capitalize }}</option>
          </b-form-select>
        </b-form-group>
      </b-card>
      <b-row>
        <b-col class="settings-block">
          <div class="settings-container" v-if="!editUser">
            <p>{{ $t('PROFILE.EMAIL_NOTIFY') }}</p>
            <c-switch type="3d" variant="success" :checked="this.user.notify" @change="pSwitchChanged" />
          </div>
        </b-col>
      </b-row>
      <div slot="footer">
        <b-button type="submit" size="sm" variant="secondary" class="padding-x-2" @click="formSubmit()"><i class="fa fa-dot-circle-o"></i> {{ $t('COMMON.SUBMIT') }}</b-button>
        <b-button type="reset" size="sm" class="padding-x-2" variant="gray" @click="cancelForm()" v-if="this.editUser"><i class="fa fa-ban"></i> Cancel</b-button>
        <b-button type="reset" size="sm" class="padding-x-2" variant="gray" @click="resetForm()" v-else><i class="fa fa-ban"></i> {{ $t('COMMON.RESET') }}</b-button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { required, requiredIf, email, minLength, alphaNum } from 'vuelidate/lib/validators'
import cSwitch from '@/components/Switch'

export default {
  props: ['user', 'roles', 'teams', 'accounts', 'isSuperAdmin', 'isAdmin', 'editUser'],
  computed: {
    passwordRequired () {
      return !this.editUser
    }
  },
  components: {
    'c-switch': cSwitch
  },
  validations: {
    user: {
      email: {
        required,
        email
      },
      username: {
        required,
        alphaNum,
        minLen: minLength(5)
      },
      // password: {
      //   required: requiredIf(function () { return !this.editUser }),
      //   minLen: minLength(8)
      // },
      // repeat_password: {
      //   required: requiredIf(function () { return !this.editUser }),
      //   sameAs: sameAs(vm => { return vm.password })
      // },
      role_id: {
        required
      },
      account_id: {
        required: requiredIf(function () { return this.isSuperAdmin })
      }
    }
  },
  methods: {
    pSwitchChanged () {
      this.user.notify = !this.user.notify
    },
    formSubmit: function () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$emit('formSubmit', this.user)
      }
    },
    resetForm: function () {
      this.$emit('formReset')
    },
    cancelForm: function () {
      this.$emit('cancelForm')
    }
  }
}
</script>

<style lang="scss" scoped>
  .error-message {
    color: #f86c6b;
    font-size: 0.75rem;
    font-family: 'Lato', sans-serif;
  }
</style>




// WEBPACK FOOTER //
// src/components/admin/userForm.vue